import React, { Component, ErrorInfo } from 'react';
import Error from '../pages/error';

interface Props {
	children: React.ReactNode;
}

interface State {
	error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
	state = { error: null };

	static getDerivedStateFromError(error: Error): State {
		return { error };
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
		console.log(error, errorInfo);
	}

	render() {
		if (this.state.error) return <Error error={this.state.error} />;

		return this.props.children;
	}
}

export default ErrorBoundary;
